export default class BookmarkItem {
  constructor ($el) {
    this.onBookmarkRemoved = this.onBookmarkRemoved.bind(this)
    this.onBookmarkAdded = this.onBookmarkAdded.bind(this)
    this.$el = $el
    this.jobId = parseInt(this.$el.data('jobId'))
    this.addEventListeners()
  }

  addEventListeners () {
    EventBus.on('bookmarks:removed', this.onBookmarkRemoved)
    EventBus.on('bookmarks:added', this.onBookmarkAdded)
  };

  onBookmarkAdded (_event, jobId) {
    if (jobId === this.jobId) {
      this.$el.fadeIn()
    }
  }

  onBookmarkRemoved (_event, jobId) {
    if (jobId === this.jobId) {
      this.$el.fadeOut()
    }
  };
}
